import gql from 'graphql-tag';

const subscriptionProductTypeQuery = gql`
  query subscriptionProductTypeQuery {
    subscriptionProductType {
      key
      text
      value
      productCode
    }
  }
`;

export default subscriptionProductTypeQuery;
